import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    value: 0,
};

const appSlice = createSlice({
    name: 'counter',
    initialState,
    reducers: {
        increment: (state) => {
            state.value += 1;
        },
        decrement: (state) => {
            state.value -= 1;
        },
    },
});

export const { increment, decrement } = appSlice.actions;
export default appSlice.reducer;
